import React, { FunctionComponent } from 'react'
import { CenterPanel, SidePanel } from '../routesLayout'
import { StagingOrdersGrid } from './StagingOrdersGrid/StagingOrdersGrid'
import { SendRFQPanel } from './SendRFQPanel'
import { StagingOrdersHeroPanel } from 'view/routes/staging/StagingOrdersHeroPanel'
import { OrderDropzoneProvider } from 'view/shared/orderUpload'

export const StagingScreen: FunctionComponent = () => {
  return (
    <OrderDropzoneProvider>
      <CenterPanel>
        <StagingOrdersHeroPanel />
        <StagingOrdersGrid />
      </CenterPanel>
      <SidePanel>
        <SendRFQPanel />
      </SidePanel>
    </OrderDropzoneProvider>
  )
}
